<template>
  <div class="logo-full-left-content">
    <div class="description-full-left-wrapper">
      <div class="logo-full-left-icon-wrapper">
        <p class="logo-full-left-title" >
          {{ logoFullSignatureDescription14 }}
        </p>
      </div>
    </div>
    <div
      class="logo-full-left-card-item-4"
      :style="{ backgroundImage: `url(${logoFullSignatureImageSrc7})` }"
    ></div>    
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import VisualIdentityPageMixin from '@/mixins/visual-identity-page-mixin'
import { VisualIdentityPageStore } from '@/store/visual-identity-page/visual-identity-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class LogoSignatureAlignedLeftSection extends Mixins(VisualIdentityPageMixin) {
  visualIdentityPageStore: PageStoreContract = getModule(VisualIdentityPageStore, this.$store)

  get logoFullSignatureDescription14(): string {
    return this.getElementText(15, 16)
  }

  get logoFullSignatureImageSrc7(): string {
    return this.getElementMedia(15, 17)
  }  

  async getVisualIdentityPage(): Promise<void> {
    await this.visualIdentityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.visualIdentityPageStore.isLoading) {
      await this.getVisualIdentityPage()
    }
  }
}
</script>

<style lang="scss">
.logo-full-left-content {
  display: grid;
  width: 100%;
  max-width: 1032px;
}

.description-full-left-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;  
}

.logo-full-left-title {
  font-size: 30px;
  font-weight: 300;
  line-height: 20px;
  text-align: left;

  width: 100%;  
}

.logo-full-left-icon-wrapper {
  display: flex;
  align-items: center;
}

.logo-full-left-card-item {
  position: relative;
  bottom: 0;
  width: 95%;
  max-width: 1045px;
  height: 558px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.logo-full-left-card-item-4 {
  position: relative; 

  max-width: 1032px;
  width: 100%;
  height: 705px;

  border-radius: 20px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.logo-full-left-card-item-5 {
  position: relative;
  
  max-width: 1032px;
  width: 100%;
  height: 531px;

  border-radius: 20px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>
